import { DataFormat } from "utils/format/DataFormat";

export abstract class BaseFilterListRequestModel {
  name?: string;
  code?: string;
  page?: number;
  order?: string;
  service?: string;
  limit?: number;

  public removeUnknowValue<T extends BaseFilterListRequestModel>(data: T) {
    return DataFormat.removeUndefined(
      data as unknown as Record<string, unknown>
    );
  }
}
